export * from './eventLog.service';
import * as Actions from './actions';

export {
  Actions
};



// WEBPACK FOOTER //
// ./src/app/services/eventLog/index.ts